<template>
    <b-container fluid>
        <b-row>
            <b-col>
                <SearchComponent v-model="vendor"
                    :disabled="mode==='edit'"
                    search-u-r-l="/Vendor"
                    prepopulate
                    :id="vendor && vendor.id"></SearchComponent>
            </b-col>
            <b-col cols="3">
                <b-form-group label="Price:">
                    <b-form-input id="vendorPrice"
                                  v-model.number="syncedPrice"
                                  type="number"
                                  :no-wheel="true">
                    </b-form-input>
                </b-form-group>
            </b-col>
            <b-col cols="1">
                <b-form-group label="Primary">
                    <b-form-checkbox v-model="syncedPrimary"></b-form-checkbox>
                </b-form-group>
            </b-col>
        </b-row>
    </b-container>
</template>

<script lang="ts">
    import {Component, Vue, Prop, VModel, Model, PropSync} from 'vue-property-decorator';
    import {Vendor} from '@/models/Vendor';
    import SearchComponent from '@/components/SearchComponent.vue';

    @Component({
        name: "VendorPriceComponent",
        components: {SearchComponent},
    })
    export default class VendorPriceComponent extends Vue {
        @VModel() private vendor!: Vendor;
        @Prop() private mode!:string;
        @PropSync("price", {type: Number, default: 0}) private syncedPrice!: number;
        @PropSync("primary", {type:Boolean, default: false}) private syncedPrimary!: boolean;
        
    }
</script>

<style scoped>
</style>
